<template>
  <a
    v-if="hasViewMore"
    href="#"
    class="btn-more all"
    @click.prevent="viewMore(sectionInfo)"
    >{{ viewMoreTitle(sectionInfo, '더보기') }}</a
  >
</template>
<script>
  import MultiSectionMixin from '@/mixins/multisection.mixin'

  export default {
    name: 'CatalogBandViewMore',
    mixins: [MultiSectionMixin],
    props: {
      sectionInfo: {
        type: Object,
        default: () => {},
      },
    },
  }
</script>
